// src/components/FullScreenLoader.jsx
import React from "react";
import "../cstm.style.css";

const FullScreenLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-spinner" />
    </div>
  );
};

export default FullScreenLoader;
